import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import ReactEcharts from 'echarts-for-react';
import { Col, DatePicker, Row, Select, Spin, } from 'antd';
import moment from 'moment';
import _ from 'lodash';

import * as channelController from '../../../../../../services/api/channel';
import * as programmeController from '../../../../../../services/api/programme';
import { leadTypeOptions, leadSourceOptions, leadStatusOptions } from '../../../../../../utils/options';
import getBetweenDates from '../../../../../../utils/getBetweenDates';

const { RangePicker } = DatePicker;
const { Option } = Select;

export class ChannelInsight extends Component {
    constructor(props) {
        super(props);

        this.state = {
            channels: [],
            programmes: [],
            selectedChannels: [parseInt(props.match.params.channelId, 10)],
            selectedDateRanges: [moment().subtract(7, 'days'), moment()],
            selectedProgramme: undefined,
            selectedLeadSource: undefined,
            selectedLeadType: undefined,
            selectedLeadStatus: undefined,
            overallDistribution: {
                numberOfEnrolledLead: 0,
                numberOfLead: 0,
            },
            totalDistribution: {
                numberOfEnrolledLead: 0,
                numberOfLead: 0,
            },
            leadDistribution: [],
            enrollmentDistribution: [],
            isLoading: false
        }
    }

    fetchChannels() {
        this.setState({ isLoading: true });

        channelController.getChannels({ isSimple: true })
            .then((res) => res.json())
            .then((json) => this.setState({ channels: json, isLoading: false }))
    }

    fetchProgrammes() {
        this.setState({ isLoading: true });

        programmeController.getProgrammes({ isSimple: true })
            .then((res) => res.json())
            .then((json) => this.setState({ programmes: json, isLoading: false }))
    }

    fetchOverallDistribution() {
        const { match } = this.props;
        const { selectedDateRanges, selectedProgramme, selectedLeadSource, selectedLeadType, selectedLeadStatus } = this.state;
        const channelId = match.params.channelId;
        this.setState({ isLoading: true });

        channelController.getChannelOverallDistribution({
                channel_ids: [channelId],
                programme_id: selectedProgramme,
                lead_source: selectedLeadSource,
                lead_type: selectedLeadType,
                lead_status: selectedLeadStatus,
                since: selectedDateRanges[0].startOf('day').toISOString(),
                until: selectedDateRanges[1].endOf('day').toISOString()
            })
            .then((res) => res.json())
            .then((json) => {
                let newState = { isLoading: false };

                if (json.length !== 0) {
                    newState.overallDistribution = {
                        numberOfEnrolledLead: json[0].number_of_enrolled_lead,
                        numberOfLead: json[0].number_of_lead
                    }
                } else {
                    newState.overallDistribution = {
                        numberOfEnrolledLead: 0,
                        numberOfLead: 0
                    }
                }

                this.setState(newState);
            })
    }

    fetchTotalDistribution() {
        const { match } = this.props;
        const channelId = match.params.channelId;
        this.setState({ isLoading: true });

        channelController.getChannelOverallDistribution({
                channel_ids: [channelId]
            })
            .then((res) => res.json())
            .then((json) => {
                let newState = { isLoading: false };

                if (json.length !== 0) {
                    newState.totalDistribution = {
                        numberOfEnrolledLead: json[0].number_of_enrolled_lead,
                        numberOfLead: json[0].number_of_lead
                    }
                }

                this.setState(newState);
            })
    }

    fetchLeadDistribution() {
        const { channels, selectedChannels, selectedDateRanges, selectedProgramme, selectedLeadSource, selectedLeadType, selectedLeadStatus } = this.state;
        this.setState({ isLoading: true });

        channelController.getChannelLeadDistribution({
                channel_ids: selectedChannels,
                programme_id: selectedProgramme,
                lead_source: selectedLeadSource,
                lead_type: selectedLeadType,
                lead_status: selectedLeadStatus,
                since: selectedDateRanges[0].startOf('day').toISOString(),
                until: selectedDateRanges[1].endOf('day').toISOString()
            })
            .then((res) => res.json())
            .then((json) => {
                const dates = getBetweenDates(selectedDateRanges[0], selectedDateRanges[1]);
                let results = _.map(selectedChannels, (channel) => ({ id: channel, name: (_.find(channels, { id: channel }) || {}).name, data: _.fill(Array(dates.length), 0) }));

                _.forEach(json, (record) => {
                    const targetIndex = _.indexOf(dates, moment(record.timestamp).format('DD/MM/YYYY'));
                    if (targetIndex !== -1) {
                        const targetDataset = _.find(results, { id: record.channel_id });
                        targetDataset.data[targetIndex] = record.number_of_lead;
                    }
                })

                this.setState({ leadDistribution: results, isLoading: false });
            })
    }

    fetchEnrollmentDistribution() {
        const { channels, selectedChannels, selectedDateRanges, selectedProgramme, selectedLeadSource, selectedLeadType, selectedLeadStatus } = this.state;
        this.setState({ isLoading: true });

        channelController.getChannelEnrollmentDistribution({
                channel_ids: selectedChannels,
                programme_id: selectedProgramme,
                lead_source: selectedLeadSource,
                lead_type: selectedLeadType,
                lead_status: selectedLeadStatus,
                since: selectedDateRanges[0].startOf('day').toISOString(),
                until: selectedDateRanges[1].endOf('day').toISOString()
            })
            .then((res) => res.json())
            .then((json) => {
                const dates = getBetweenDates(selectedDateRanges[0], selectedDateRanges[1]);
                let results = _.map(selectedChannels, (channel) => ({ id: channel, name: (_.find(channels, { id: channel }) || {}).name, data: _.fill(Array(dates.length), 0) }));

                _.forEach(json, (record) => {
                    const targetIndex = _.indexOf(dates, moment(record.timestamp).format('DD/MM/YYYY'));
                    if (targetIndex !== -1) {
                        const targetDataset = _.find(results, { id: record.channel_id });
                        targetDataset.data[targetIndex] = record.number_of_enrolled_lead;
                    }
                })

                this.setState({ enrollmentDistribution: results, isLoading: false });
            })
    }

    getLeadChartOption() {
        const { selectedDateRanges, leadDistribution } = this.state;

        const option = {
            tooltip: {
                trigger: 'axis',
            },
            toolbox: {
                show: true,
                feature: {
                    saveAsImage: {
                        title: 'Save as image'
                    }
                }
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: getBetweenDates(selectedDateRanges[0], selectedDateRanges[1])
            },
            yAxis: {
                type: 'value',
                axisPointer: {
                    snap: true
                },
                interval: 1
            },
            legend: {
                data: _.map(leadDistribution, (series) => series.name)
            },
            series: _.map(leadDistribution, (series) => ({
                name: series.name,
                type: 'line',
                smooth: true,
                data: series.data,
            }))
        };

        return option;
    }

    getEnrollmentChartOption() {
        const { selectedDateRanges, enrollmentDistribution } = this.state;

        const option = {
            tooltip: {
                trigger: 'axis',
            },
            toolbox: {
                show: true,
                feature: {
                    saveAsImage: {
                        title: 'Save as image'
                    }
                }
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: getBetweenDates(selectedDateRanges[0], selectedDateRanges[1])
            },
            yAxis: {
                type: 'value',
                axisPointer: {
                    snap: true
                },
                interval: 1
            },
            legend: {
                data: _.map(enrollmentDistribution, (series) => series.name)
            },
            series: _.map(enrollmentDistribution, (series) => ({
                name: series.name,
                type: 'line',
                smooth: true,
                data: series.data,
            }))
        };

        return option;
    }

    componentDidMount() {
        this.fetchChannels();
        this.fetchProgrammes();
        this.fetchOverallDistribution();
        this.fetchTotalDistribution();
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            channels,
            selectedChannels,
            selectedDateRanges,
            selectedProgramme,
            selectedLeadSource,
            selectedLeadType,
            selectedLeadStatus
        } = this.state;

        if ((!_.isEqual(channels, prevState.channels) && channels.length !== 0) ||
            !_.isEqual(selectedChannels, prevState.selectedChannels) ||
            !_.isEqual(selectedDateRanges, prevState.selectedDateRanges) ||
            selectedProgramme !== prevState.selectedProgramme ||
            selectedLeadSource !== prevState.selectedLeadSource ||
            selectedLeadType !== prevState.selectedLeadType ||
            selectedLeadStatus !== prevState.selectedLeadStatus) {
            this.fetchLeadDistribution();
            this.fetchEnrollmentDistribution();
        }

        if (!_.isEqual(selectedDateRanges, prevState.selectedDateRanges) ||
            selectedProgramme !== prevState.selectedProgramme ||
            selectedLeadSource !== prevState.selectedLeadSource ||
            selectedLeadType !== prevState.selectedLeadType ||
            selectedLeadStatus !== prevState.selectedLeadStatus) {
            this.fetchOverallDistribution();
        }
    }

    render() {
        const { match } = this.props;
        const {
            channels,
            programmes,
            selectedChannels,
            selectedDateRanges,
            selectedProgramme,
            selectedLeadSource,
            selectedLeadType,
            selectedLeadStatus,
            overallDistribution,
            totalDistribution,
            isLoading
        } = this.state;
        const channelId = match.params.channelId;
        const currentChannelName = (_.find(channels, { id: parseInt(channelId, 10) }) || {}).name || channelId;

        const channelOptions = _.map(channels, (channel) => <Option key={channel.id} value={channel.id}>{channel.name}</Option>);
        const programmeOptions = _.map(programmes, (programme) => <Option key={programme.id} value={programme.id}>{programme.name}</Option>);
        const leadSourceOptionComponents = _.map(leadSourceOptions, (item) => <Option key={item} value={item}>{item}</Option>);
        const leadTypeOptionComponents = _.map(leadTypeOptions, (item) => <Option key={item} value={item}>{item}</Option>);
        const leadStatusOptionComponents = _.map(leadStatusOptions, (item) => <Option key={item} value={item}>{item}</Option>);

        return (
            <Spin spinning={isLoading}>
                <div className="InsightSection">
                    <Row gutter={16} className="option-bar">
                        <Col span={24}>
                        	<div className="query-option">
	                        	<label>Select Channel(s) to Compare: </label>
	                            <Select
	                                mode="multiple"
	                                style={{ width: 500 }}
	                                value={selectedChannels}
	                                onChange={(value) => this.setState({ selectedChannels: value} )}
	                            >
	                                {channelOptions}
	                            </Select>
                            </div>
                            {" "}
                        	<div className="query-option">
	                        	<label>Select Range: </label>
	                            <RangePicker
	                                value={selectedDateRanges}
	                                onChange={(dates, dateStrings) => this.setState({ selectedDateRanges: dates })}
	                            />
                            </div>
                        </Col>
                    </Row>
                    <Row gutter={16} className="option-bar">
                        <Col span={24}>
                        	<div className="query-option">
	                        	<label>Programme: </label>
	                            <Select
	                            	allowClear
	                                style={{ width: 200 }}
	                                placeholder="(All)"
	                                vallue={selectedProgramme}
	                                onChange={(value) => this.setState({ selectedProgramme: value })}
	                            >
	                                {programmeOptions}
	                            </Select>
                            </div>
                            {" "}
                        	<div className="query-option">
	                        	<label>Lead Source: </label>
	                            <Select
	                            	allowClear
	                                style={{ width: 200 }}
	                                placeholder="(All)"
	                                vallue={selectedLeadSource}
	                                onChange={(value) => this.setState({ selectedLeadSource: value })}
	                            >
	                                {leadSourceOptionComponents}
	                            </Select>
                            </div>
                            {" "}
                        	<div className="query-option">
	                        	<label>Lead Type: </label>
	                            <Select
	                            	allowClear
	                                style={{ width: 200 }}
	                                placeholder="(All)"
	                                vallue={selectedLeadType}
	                                onChange={(value) => this.setState({ selectedLeadType: value })}
	                            >
	                                {leadTypeOptionComponents}
	                            </Select>
                            </div>
                            {" "}
                        	<div className="query-option">
	                        	<label>Lead Status: </label>
	                            <Select
	                            	allowClear
	                                style={{ width: 200 }}
	                                placeholder="(All)"
	                                vallue={selectedLeadStatus}
	                                onChange={(value) => this.setState({ selectedLeadStatus: value })}
	                            >
	                                {leadStatusOptionComponents}
	                            </Select>
                            </div>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col lg={12} xs={24}>
                            <h3>{`Distribution across types within the range (${currentChannelName})`}</h3>
                            <p>Number of Enrolled Lead: {overallDistribution.numberOfEnrolledLead}</p>
                            <p>Number of Lead: {overallDistribution.numberOfLead}</p>
                        </Col>
                        <Col lg={12} xs={24}>
                            <h3>{`Total as of today (${currentChannelName})`}</h3>
                            <p>Number of Enrolled Lead: {totalDistribution.numberOfEnrolledLead}</p>
                            <p>Number of Lead: {totalDistribution.numberOfLead}</p>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col lg={12} xs={24}>
                            <h3>Distribution of Lead</h3>
                            <ReactEcharts
                                notMerge
                                theme={'informatics'}
                                option={this.getLeadChartOption()}
                            />
                        </Col>
                        <Col lg={12} xs={24}>
                            <h3>Distribution of Enrollment</h3>
                            <ReactEcharts
                                notMerge
                                theme={'informatics'}
                                option={this.getEnrollmentChartOption()}
                            />
                        </Col>
                    </Row>
                </div>
            </Spin>
        );
    }
}

export default withRouter(ChannelInsight);


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/ChannelManagementPage/components/ChannelInsight/ChannelInsight.js